import { HANDLE_HAMMER, RESET } from '../actions';

const initialState = {
    hammerList: [],
    hammerCopy: [],
    search: "",
    vehicleFilter: ""
};

const HammerDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_HAMMER:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default HammerDetails;